import {Component} from '@angular/core';
import {MdDialog} from '@angular/material';
/**
 * \@title Dialog with header, scrollable content and actions
 */
export class DialogContentExample {
/**
 * @param {?} dialog
 */
constructor(public dialog: MdDialog) {}
/**
 * @return {?}
 */
openDialog() {
    const /** @type {?} */ dialogRef = this.dialog.open(DialogContentExampleDialog, {
      height: '350px'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'dialog-content-example',
  templateUrl: 'dialog-content-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdDialog, },
];
}

function DialogContentExample_tsickle_Closure_declarations() {
/** @type {?} */
DialogContentExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DialogContentExample.ctorParameters;
/** @type {?} */
DialogContentExample.prototype.dialog;
}

export class DialogContentExampleDialog {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'dialog-content-example-dialog',
  templateUrl: 'dialog-content-example-dialog.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DialogContentExampleDialog_tsickle_Closure_declarations() {
/** @type {?} */
DialogContentExampleDialog.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DialogContentExampleDialog.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
